'use strict';

var _ = require('lodash');
var ConditionHelper = function ConditionHelper() {
  var singleToMultiMappedFields = ['segment.aircraftConfig'];
  var collectionOperators = ['contains', 'not contains'];
  function isSingleToMultiValueMapped(condition) {
    return _.includes(singleToMultiMappedFields, condition.field) && _.includes(collectionOperators, condition.operator);
  }
  return {
    isSingleToMultiValueMapped: isSingleToMultiValueMapped
  };
};
module.exports = ConditionHelper;